import { useState, useCallback } from 'react'
import { DeleteOutlined } from '@ant-design/icons'
import { message } from 'antd'
import PropTypes from 'prop-types'
import { useAppDispatch } from '../../hooks'
import { onDeleteUser } from '../../redux/user/user.action'
import PopconfirmCommon from '../PopconfirmCommon/PopconfirmCommon'

export const UserListAction = ({ user }) => {
	const dispatch = useAppDispatch()
	const [visible, setVisible] = useState(false)
	const [confirmLoading, setConfirmLoading] = useState(false)

	const deleteUserCallback = useCallback(isSuccess => {
		if (isSuccess) {
			setConfirmLoading(false)
			setVisible(false)
		} else {
			message.error('Something went wrong')
		}
	}, [])

	const onConfirm = () => {
		setConfirmLoading(true)
		dispatch(onDeleteUser(user.id, deleteUserCallback))
	}

	const onCancel = () => {
		setVisible(false)
	}

	const showPopconfirm = () => {
		setVisible(true)
	}

	return (
		<div>
			<PopconfirmCommon
				visible={visible}
				onConfirm={onConfirm}
				title="Are you sure to delete this user permanently?"
				placement="left"
				okButtonProps={{ loading: confirmLoading }}
				onCancel={onCancel}
			>
				<DeleteOutlined onClick={showPopconfirm} />
			</PopconfirmCommon>
		</div>
	)
}

UserListAction.propTypes = {
	user: PropTypes.any,
}
